import { RouteParams } from "@/hooks/useRouteParams";
import { parse, stringify } from "qs";

const FOUND_IT_TRACKING_PARAM = "fi";

type Options = {
  retainFoundItTracking?: boolean;
};

export function sanitiseQueryParams(
  query: RouteParams["query"] | string,
  options: Options = {},
): string {
  const q =
    typeof query === "string"
      ? parse(query, { ignoreQueryPrefix: true })
      : query;

  return stringify(q, {
    encode: false,
    sort: (a, b) => a.localeCompare(b),
    filter: (key, value) => {
      switch (key) {
        case "search-term":
          return encodeURIComponent(value);
        case FOUND_IT_TRACKING_PARAM:
          return options.retainFoundItTracking ? value : undefined;
        default:
          return value;
      }
    },
    arrayFormat: "repeat",
  });
}

export function onlyChunkParamHasChanged(
  newParams: URLSearchParams,
  existingParams: URLSearchParams,
): boolean {
  const chunkHasChanged =
    newParams.get("chunk") !== existingParams.get("chunk");

  const otherParamsIdentical =
    getSortedParamStringWithoutChunk(newParams.toString()) ===
    getSortedParamStringWithoutChunk(existingParams.toString());

  return chunkHasChanged && otherParamsIdentical;
}

const getSortedParamStringWithoutChunk = (paramString: string): string => {
  const params = new URLSearchParams(paramString);
  params.delete("chunk");
  params.sort();
  return params.toString();
};
